import { inject, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CurrencyService } from '../../services/currency.service';

/**
 * Resolve correct format for currencies
 */
@Pipe({
    name: 'currencyFormat',

})
export class CurrencyFormatPipe implements PipeTransform {
  private _number = inject(DecimalPipe);
  private _currency = inject(CurrencyService);


  transform(value: any, currency: string): any {
    switch (true) {
      case this._currency.isCryptoCurrency(currency) && value !== 0:
        return value;
      default:
        return this._number.transform(value, '0.2');
    }
  }

}
